export default class PlaylistItemAsset {
  constructor(obj) {
    this.imageUrl = obj.image_url
    this.linkId = obj.link.id
    this.subTitle = obj.subTitle
    this.title = obj.title

    this.coverComp = 'PlaylistCover'
    this.type = 'playlist'
  }
}
